<div class="screen screen--plan">

  <header class="screen__head">
    <p class="belturo-eyebrow"><%= _lcs( 'Dein Aufenthalt' ) %></p>
    <h1 class="screen__title"><%= _lcs( 'Mein Planer' ) %></h1>
    <p class="screen__sub"><%= _lcs( 'Plane deine Reise — Tag für Tag.' ) %></p>
  </header>

  <div class="planintro">
    <span class="planintro__icon"><i class="icon icon--route"></i></span>
    <h2 class="planintro__title"><%= _lcs( 'Noch kein Reiseplan' ) %></h2>
    <p class="planintro__text">
      <%= _lcs( 'Gib deinem Reiseplan einen Namen und verrate uns den Zeitraum deines Aufenthalts. Danach sammelst du überall in der App Favoriten mit „Zum Planer hinzufügen“ und verteilst sie auf deine Tage.' ) %>
    </p>

    <ul class="planintro__steps">
      <li><span class="planintro__step">1</span> <%= _lcs( 'Zeitraum festlegen' ) %></li>
      <li><span class="planintro__step">2</span> <%= _lcs( 'Favoriten sammeln' ) %></li>
      <li><span class="planintro__step">3</span> <%= _lcs( 'Auf die Tage verteilen' ) %></li>
    </ul>

    <button class="btn btn--primary btn--lg btn--block" type="button" data-act="new">
      <i class="icon icon--plus"></i> <%= _lcs( 'Reiseplan erstellen' ) %>
    </button>
  </div>

  <% if ( failed ) { %>
    <p class="plan__note plan__note--error">
      <i class="icon icon--triangle-alert"></i>
      <%= _lcs( 'Deine Reisepläne konnten nicht geladen werden. Versuch es später noch einmal.' ) %>
    </p>
  <% } %>

</div>
